import Api from './api';

const PATH = '/ai-suggestion/settings';

const getByLLMId = async (llmId) => {
  try {
    const response = await Api.get(`${PATH}/${llmId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const update = async (llmId, payload) => {
  try {
    const response = await Api.put(`${PATH}/${llmId}`, payload);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export {
  getByLLMId,
  update
};
